import { render, staticRenderFns } from "./GendecPage.vue?vue&type=template&id=28120f8a&scoped=true"
import script from "./GendecPage.vue?vue&type=script&lang=js"
export * from "./GendecPage.vue?vue&type=script&lang=js"
import style0 from "./GendecPage.vue?vue&type=style&index=0&id=28120f8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28120f8a",
  null
  
)

export default component.exports